const crypto = require('crypto');
const algorithm = 'aes-256-cbc';

function encryptUserId(userId, privateKey) {
    const key = crypto.createHash('sha256').update(privateKey).digest('base64').substr(0, 32);
    // Use a fixed IV for consistency
    const iv = Buffer.from('1234567890123456', 'utf8');
    const cipher = crypto.createCipheriv(algorithm, key, iv);
    let encrypted = cipher.update(userId, 'utf8', 'hex');
    encrypted += cipher.final('hex');
    // const encryptedData = iv.toString('hex') + ':' + encrypted;
    const encryptedData = encrypted;
    return encryptedData;
}

// Function to decrypt an encrypted user ID
function decryptUserId(encryptedUserId, privateKey) {
    const key = crypto.createHash('sha256').update(privateKey).digest('base64').substr(0, 32);
    // const [ivHex, encryptedHex] = encryptedUserId.split(':');
    const ivHex = `${process.env.encryptionInitializationVector}`;
    const encryptedHex = encryptedUserId;
    const iv = Buffer.from(ivHex, 'hex');
    // const iv = Buffer.from('1234567890123456', 'utf8');
    const decipher = crypto.createDecipheriv(algorithm, key, iv);
    let decrypted = decipher.update(encryptedHex, 'hex', 'utf8');
    decrypted += decipher.final('utf8');
    return decrypted + '@ADOBEID';
}

export const doEncryption = (userId) => {
    const parts = userId.split('@');
    const secretKey = `${process.env.NEXT_PUBLIC_secretKey}`;
    const token = encryptUserId(parts[0], secretKey);
    return token;
}

export const doDecryption = (encryptedGuid) => {
    const secretKey = `${process.env.secretKey}`;
    const decryptedGuid = decryptUserId(encryptedGuid, secretKey);
    return decryptedGuid;
}